
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M357.437 0H154.562C122.822 0 97 25.822 97 57.562v396.876C97 486.178 122.822 512 154.562 512h202.876c31.74 0 57.562-25.822 57.562-57.562V57.562C414.999 25.822 389.177 0 357.437 0zm27.267 454.438c-.001 15.035-12.232 27.266-27.267 27.266H154.562c-15.035 0-27.266-12.231-27.266-27.266v-32.032h257.409v32.032zm0-62.328H127.296V99.956h257.409V392.11zm0-322.45H127.296V57.562c0-15.035 12.231-27.266 27.266-27.266h202.876c15.035 0 27.266 12.231 27.266 27.266V69.66z"}}),_c('path',{attrs:{"d":"M278.261 438.191h-44.523c-8.366 0-15.148 6.782-15.148 15.148s6.782 15.148 15.148 15.148h44.523c8.366 0 15.148-6.782 15.148-15.148s-6.782-15.148-15.148-15.148zM255.999 230.885c-11.435 0-20.739-9.303-20.739-20.739s9.303-20.738 20.739-20.738h35.886c8.366 0 15.148-6.782 15.148-15.148s-6.782-15.148-15.148-15.148h-20.739v-15.731c0-8.366-6.782-15.148-15.148-15.148s-15.148 6.782-15.148 15.148v18.026c-20.767 6.468-35.886 25.871-35.886 48.739 0 28.14 22.894 51.034 51.034 51.034 11.435 0 20.739 9.303 20.739 20.739s-9.304 20.739-20.739 20.739h-35.886c-8.366 0-15.148 6.782-15.148 15.148s6.782 15.148 15.148 15.148h20.739v15.731c0 8.366 6.782 15.148 15.148 15.148s15.148-6.782 15.148-15.148v-18.026c20.767-6.468 35.886-25.871 35.886-48.739.001-28.141-22.893-51.035-51.034-51.035z"}})])
          )
        }
      }
    